const storageKey = "syscofy-auth-email-handoff";

export function storeEmailHandoff(value) {
	const email = String(value || "").trim();
	if (!email || email.length > 254) return;
	try {
		sessionStorage.setItem(storageKey, email);
	} catch (_error) {
		// Navigation still works when browser storage is unavailable.
	}
}

export function takeEmailHandoff() {
	let email = "";
	try {
		email = sessionStorage.getItem(storageKey) || "";
		sessionStorage.removeItem(storageKey);
	} catch (_error) {
		return "";
	}
	return email.length <= 254 ? email : "";
}
